import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FriendbuyService {
  public getReferralCode(): string | null {
    return sessionStorage.getItem('referralCode');
  }
}
